import {
  InternalTransferMethodEnum,
  InternalTransferSubmit,
  InternalTransferTypeEnum,
} from '@interfaces';

/*
 * Removes restricted holdings from the payload if the entire account is being transferred and the account has restricted holdings.
 * We want to do this upon submit because we need to display "entire account" at other points in the flow post-transfer-from,
 * but we don't want to submit restricted holdings and we need the BPM comment not to say transfer all holdings
 */
export function removeRestrictedHoldings(submitPayload: InternalTransferSubmit) {
  let submitPayloadCopy = { ...submitPayload };
  const isEntireAccount =
    submitPayloadCopy.itConfig.internalTransfer.transferFrom.transferType ===
    InternalTransferTypeEnum.ENTIRE_ACCOUNT;
  const holdsRestrictedPositions =
    submitPayloadCopy.itConfig.internalTransfer.transferFrom.selectedAccount.accountData.positions.some(
      (position) => position.restricted,
    );
  if (isEntireAccount && holdsRestrictedPositions) {
    submitPayloadCopy = {
      ...submitPayloadCopy,
      itConfig: {
        ...submitPayloadCopy.itConfig,
        internalTransfer: {
          ...submitPayloadCopy.itConfig.internalTransfer,
          transferFrom: {
            ...submitPayloadCopy.itConfig.internalTransfer.transferFrom,
            transferType: InternalTransferTypeEnum.PARTIAL,
            transferMethod: InternalTransferMethodEnum.SHARES,
          },
        },
      },
      receiptDTO: {
        ...submitPayloadCopy.receiptDTO,
        from: {
          ...submitPayloadCopy.receiptDTO.from,
          rows: submitPayloadCopy.receiptDTO.from.rows.map((row, index) =>
            index === 2 ? { ...row, values: ['Partial in shares'] } : row,
          ),
        },
      },
    };
  }
  return submitPayloadCopy;
}
